/* eslint-disable import/prefer-default-export */
export const stakingTypes = {
  ACTIVE: 'active',
  COMPLETED: 'completed',
  ENDED: 'ended',
};

export const mainStakingCurrency = 'bxx';

export const featuresModales = {
  EXCHANGE: 'exchange',
  ADD_FUNDS: 'addFunds',
};

export const featuresScreens = {
  ADD_FUNDS_OPTIONS: 'add_funds_options',
  CREATE_STAKING: 'create_staking',
  STAKING_DEAL_DETAILS: 'staking_deal_details',
};

export const benefitsTiersBadgeColorsMap = {
  tier1: { background: 'bg-black', text: 'text-dark' },
  tier2: { background: 'bg-info-light', text: 'text-info' },
  tier3: { background: 'bg-success-light', text: 'text-success' },
  tier4: { background: 'bg-warning-light', text: 'text-warning' },
  tier5: { background: 'bg-danger-light', text: 'text-danger' },
};
